import React from "react";
import { Button, CircularProgress } from "@mui/material";
import styles from "./Buttons.module.scss";

const SecondaryButton = ({
  children,
  isLoading,
  disabled,
  startIcon,
  sx,
  className,
  ...props
}) => {
  const buttonClassName = [styles.buttonBase, styles.secondaryButton, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Button
      variant="outlined"
      disabled={isLoading || disabled}
      startIcon={isLoading ? undefined : startIcon}
      className={buttonClassName}
      sx={sx}
      {...props}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default SecondaryButton;
